import { render, staticRenderFns } from "./gender-select.vue?vue&type=template&id=38453872&"
import script from "./gender-select.vue?vue&type=script&lang=ts&"
export * from "./gender-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports